const GET_MEMBER_GUESTBOOK_REQUEST = 'GET_MEMBER_GUESTBOOK_REQUEST';
const GET_MEMBER_GUESTBOOK_SUCCESS = 'GET_MEMBER_GUESTBOOK_SUCCESS';
const GET_MEMBER_GUESTBOOK_FAILURE = 'GET_MEMBER_GUESTBOOK_FAILURE';

const RECEIVE_GUESTBOOK_MESSAGE = 'RECEIVE_GUESTBOOK_MESSAGE';

import {
    MEMBER_GUESTBOOK_DELETE_MESSAGE_SUCCESS
} from './member';

import * as backend from 'backend-helpers/memberGuestbook';

const initState = {
    isLoading: false,
    list: [],
    totalCount: undefined,
    offset: undefined
};

export default function memberGuestbook(state = initState, action) {
    switch (action.type) {
        case GET_MEMBER_GUESTBOOK_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        
        case GET_MEMBER_GUESTBOOK_SUCCESS:
            const { guestbookMessages } = action.result.data,
                { list, totalCount, offset } = guestbookMessages;
    
            return {
                ...state,
                list: offset ? [ ...state.list, ...list ] : list,
                totalCount,
                offset,
                isLoading: false
            }

        case MEMBER_GUESTBOOK_DELETE_MESSAGE_SUCCESS:
            const filteredList = state.list.filter((item) => item.id !== action.id),
                memberGuestbookChanged = (state.list.length > 0 && filteredList.length != state.list.length);
    
            if (memberGuestbookChanged) {
                return {
                    ...state,
                    list: filteredList,
                    totalCount: state.totalCount - 1,
                    offset: state.offset - 1
                }
            }

        default:
            return state;
    }
};

export const getMemberGuestbook = (offset = 0) => ({
    types: [GET_MEMBER_GUESTBOOK_REQUEST, GET_MEMBER_GUESTBOOK_SUCCESS, GET_MEMBER_GUESTBOOK_FAILURE],
    promise: backend.getMemberGuestbook(offset),
    offset: offset
});

export const receiveGuestbookMessage = data => ({ type: RECEIVE_GUESTBOOK_MESSAGE, data });


// WEBPACK FOOTER //
// ./src/reducers/memberGuestbook.js